import { AlertButton } from "@ionic/vue";
import Translator from "@/plugins/Translator";
import { AlertRoles } from "@/models/AlertButtons/AlertRoles";

const translator = Translator.getInstance();
const i18n = translator.getI18nGlobalInstance();

/**
 * UI Button um eine Aktion abzubrechen
 */
export const CancelButton: AlertButton = {
	role: AlertRoles.CANCEL,
	text: i18n.t("actions.cancel"),
};
